import { useNode } from '@craftjs/core';
import React, { useCallback } from 'react';
import { Textarea } from '@descope/page-editor-components';
import { EditorTextareaSettings } from './EditorTextareaSettings';

type Props = React.ComponentProps<typeof Textarea>;

const EditorTextarea = (props: Props) => {
	const {
		connectors: { connect, drag }
	} = useNode();

	const refCb = useCallback(
		(ref: HTMLDivElement) => connect(drag(ref)),
		[connect, drag]
	);

	// we are setting the textarea to read only value so it won't pop validations error message when editing the page
	// on the generated page the input element will not be read only
	return <Textarea ref={refCb} {...props} readOnly />;
};

EditorTextarea.craft = {
	name: 'Textarea',
	props: {
		label: 'Textarea',
		placeholder: 'Textarea',
		fullWidth: true,
		required: false
	},
	related: {
		settings: EditorTextareaSettings
	}
};

export { EditorTextarea };
